<template>
  <Modal v-model="model" sticky reset-drag-position title="员工归属地" @on-cancel="cancel" scrollable :mask="false" draggable class="insert_power_pop" width="800">
    <div  style="overflow:auto;height:500px;margin-top:20px;">
      <ul id="placetree" class="ztree"></ul>
    </div>
    <div slot="footer">
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
      <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "QCellCoreEditPop",
        mixins:[publicFunClass],
        props: {
          showQCellCore:Boolean,
          // agentId:String,
          placeId:String,
          showTitle:String,
        },
        data(){
          return {
            model:false,
            inQCellCoreTreeData:[],
            roleId: '',
            placeList:[],
          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeQCellCoreEditPop");
          },
          save:function () {
              let zTree = $.fn.zTree.getZTreeObj('placetree')
              let changedNodes = zTree.getCheckedNodes(true)
              console.log(changedNodes);
              if (changedNodes.length == 0) {
                  this.$Modal.info({
                    title: '提示',
                    content: '请选择员工的归属地!'
                  })
                  return false
              }
              let permissionListStr = []
                for (let i = 0; i < changedNodes.length; i++) {
                  if(changedNodes[i].id<377){
                    permissionListStr.push(changedNodes[i].id);
                  }
              }
              console.log(permissionListStr.toString());
              let journalType="用户管理=>员工管理=>归属地";
              let menuId="9_3-8";
              let param = {
                areaIds: permissionListStr.toString(),
                id:this.roleId,
                journalType:journalType,
                menuId:menuId
              }
              let that = this
              this.$http.post('employee/doPersonalAttributionSave.json', param).then(function (res) {
                    let result = res.data.flag
                    if (result != '666') {
                      that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                      })
                      return false
                    }
                    that.$Modal.info({
                      title: '提示',
                      content: '归属地保存成功'
                    })
                    that.$emit('closeQCellCoreEditPop')
              })
          },
          initSearch:function () {//获取个人归属地
              let that = this;
              let param = {
                id: this.roleId,
              }
              this.$http.post('employee/toPersonalAttribution.json', param).then(function (res) {
                let result = res.data.flag
                if (result != '666') {
                  that.$Modal.info({
                    title: '提示',
                    content: res.data.msg
                  })
                  return false
                }
                let menuList = res.data.obj

                that.initQCellCoreGroupTree(that.placeList,menuList);
              })
          },
          //设备树初始化
          initQCellCoreGroupTree:function (placeList,checkedList) {
            this.inQCellCoreTreeData = [];
            for (let i=0;i<placeList.length;i++){
              let name=placeList[i].name;
              let pid=placeList[i].pid;
              let ID = placeList[i].id;
              let treeStr={
                id:ID,
                pId:pid,
                name:name,
                open:false,
                isParent:false,
                // busid:num
              };
              this.inQCellCoreTreeData.push(treeStr);
            }
            let that=this;
            let setting = {
                check: {
                    enable: true,
                    chkStyle: "checkbox",
                    chkboxType: { "Y": "ps", "N": "ps" },
                    autoCheckTrigger: true,
                    chkDisabledInherit: true
                },
              data: {
                simpleData: {
                  enable:true,
                  idKey: "id",
                  pIdKey: "pId",
                  rootPId: ""
                },
                key:{
                  checked:'checked'
                }
              },
              callback: {
                // onClick: zTreeOnClick
              }
            };
            let zNodes =this.inQCellCoreTreeData;
            if (zNodes){
              $(document).ready(function(){
                $.fn.zTree.init($("#placetree"), setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
              });
            }
            let zTree = $.fn.zTree.getZTreeObj("placetree");
            let node;
            // 选中
            for (let k = 0; k < checkedList.length; k++) {
                  node = zTree.getNodeByParam("id",checkedList[k]);
                  let parent = node.getParentNode();
                  if(!parent.open){
                    zTree.expandNode(parent,true,true);
                  }
                  zTree.checkNode(node,true,true);
            }
          },
          //
        },
        created(){

        },
        watch:{
          showQCellCore:function () {
            this.model=this.showQCellCore;
            this.roleId = this.placeId;
            if (this.showQCellCore) {
              let that = this;
              that.placeList = [];
              let param={
                    journalType:"null",
                    menuId:"null"
              };
              this.$http.post("employee/toAttribution.json",param) .then(function (res) {
                      let result = res.data.flag;
                      if (result != "666") {
                        that.$Message.info(res.data.msg);
                        return false;
                      }
                      that.placeList=res.data.obj;
                      that.initSearch();
              })
            }

          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/agentManage/QCellCoreEditPop.vue